<template>
  <div class="license-check-container" :style="containerStyle">
    <a
      class="mall-link"
      href="https://qcshop.xxdazz.com"
      target="_blank"
      rel="noopener noreferrer"
    >
      卡密商城
    </a>
    <div class="page-shell">

      <div class="license-check-card">
        <div class="card-header">
          <h2 class="card-title">登录千川工具账号</h2>
          <div class="tab-line">
            <span class="tab-item active">邮箱/卡密登录</span>
          </div>
        </div>

        <div class="card-body">
          <div class="input-group" v-if="!showRegisterForm">
            <input
              v-model="accountInput"
              type="text"
              class="license-input"
              placeholder="请输入邮箱或卡密"
              @keyup.enter="validateLicense"
            />
          </div>

          <div class="register-form" v-else>
            <div class="input-group register-input-group">
              <input
                v-model="registerCardNumber"
                type="text"
                class="license-input"
                placeholder="请输入注册卡密"
              />
            </div>
            <div class="input-group register-input-group">
              <input
                v-model="registerMail"
                type="text"
                class="license-input"
                placeholder="请输入注册邮箱"
              />
            </div>
          </div>

          <div class="remember-group">
            <label class="checkbox-label">
              <input
                type="checkbox"
                v-model="rememberLicense"
                class="checkbox-input"
              />
              <span class="checkbox-custom"></span>
              <span class="checkbox-text">记住登录信息</span>
            </label>
          </div>

          <div class="button-group">
            <button
              @click="handleLoginClick"
              class="validate-btn"
              :disabled="isLoading || (!showRegisterForm && !accountInput)"
            >
              <span v-if="!isLoading">{{ showRegisterForm ? '返回登录' : '登录' }}</span>
              <span v-else class="loading-text">处理中...</span>
            </button>
            <button
              @click="handleRegisterClick"
              class="register-btn"
              :disabled="isLoading || (showRegisterForm && (!registerCardNumber || !registerMail))"
            >
              {{ showRegisterForm ? '提交注册' : '注册' }}
            </button>
          </div>

          <div v-if="errorMessage" class="error-message">
            <span class="error-icon">⚠️</span>
            {{ errorMessage }}
          </div>

          <div v-if="successMessage" class="success-message">
            <span class="success-icon">✅</span>
            {{ successMessage }}
          </div>
        </div>
      </div>
    </div>

    <div class="background-mask"></div>
  </div>
</template>

<script>
import axios from 'axios'
import API_CONFIG from '@/api/config'

export default {
  name: 'LicenseCheck',
  data() {
    return {
      accountInput: '',
      registerCardNumber: '',
      registerMail: '',
      showRegisterForm: false,
      rememberLicense: true,
      isLoading: false,
      errorMessage: '',
      successMessage: ''
    }
  },
  computed: {
    containerStyle() {
      return {
        backgroundImage: `url(${process.env.BASE_URL}qianchuan.jpg)`
      }
    }
  },
  mounted() {
    this.loadSavedLicense();
  },
  methods: {
      loadSavedLicense() {
        const savedLicense = localStorage.getItem('savedLicenseKey');
        const rememberSetting = localStorage.getItem('rememberLicense');
        
        if (savedLicense && rememberSetting === 'true') {
          this.accountInput = savedLicense;
          this.rememberLicense = true;
        }
      },
      
      saveLicense() {
        if (this.rememberLicense && this.accountInput.trim()) {
          localStorage.setItem('savedLicenseKey', this.accountInput.trim());
          localStorage.setItem('rememberLicense', 'true');
        } else {
          localStorage.removeItem('savedLicenseKey');
          localStorage.setItem('rememberLicense', 'false');
        }
      },
      
      async validateLicense() {
      const inputValue = this.accountInput.trim()
      if (!inputValue) {
        this.errorMessage = '请输入卡密或邮箱'
        return
      }
      
      this.isLoading = true
      this.errorMessage = ''
      this.successMessage = ''
      
      try {
        // 调用真实API进行登录验证（支持卡密或邮箱）
        const payload = {
          cardNumber: inputValue,
          mail: inputValue
        }
        const primaryLoginUrl = API_CONFIG.getLoginUrl()
        let response
        try {
          response = await axios.post(primaryLoginUrl, payload, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
        } catch (primaryError) {
          const message = String(primaryError?.response?.data?.msg || primaryError?.message || '')
          const shouldFallback = primaryError?.response?.status === 405 || message.includes("Request method 'GET' not supported")
          if (!shouldFallback) {
            throw primaryError
          }
          const fallbackLoginUrl = primaryLoginUrl.endsWith('/') ? primaryLoginUrl.slice(0, -1) : `${primaryLoginUrl}/`
          response = await axios.post(fallbackLoginUrl, payload, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
        }
        
        this.isLoading = false
        
        // 根据API响应处理结果
        if (response.data && response.data.code === 200) {
          const responseData = response?.data?.data || response?.data || {}
          const token = response?.data?.data?.token ?? response?.data?.token
          const serverCardNumber = responseData?.cardNumber
          const remainDays = responseData?.remainDays
          const remainAuthorizedCount = responseData?.remainAuthorizedCount
          const serverVersionCode = responseData?.version_code
          const serverVersionName = responseData?.version_name
          const downloadUrl = responseData?.download_url
          const updateContent = responseData?.update_content

          this.successMessage = '卡密验证成功！正在跳转...'
          
          // 保存token和卡号到本地存储
          localStorage.setItem('authToken', token != null ? String(token) : '')
          localStorage.setItem('cardNumber', serverCardNumber != null ? String(serverCardNumber) : inputValue)
          localStorage.setItem('remainDays', remainDays != null ? String(remainDays) : '0')
          localStorage.setItem('remainAuthorizedCount', remainAuthorizedCount != null ? String(remainAuthorizedCount) : '0')
          localStorage.setItem('serverVersionCode', serverVersionCode != null ? String(serverVersionCode) : '')
          localStorage.setItem('serverVersionName', serverVersionName != null ? String(serverVersionName) : '')
          localStorage.setItem('downloadUrl', downloadUrl != null ? String(downloadUrl) : '')
          localStorage.setItem('updateContent', updateContent != null ? String(updateContent) : '')
          
          // 保存记住密码设置
          this.saveLicense()
          
          // 2秒后跳转到首页
          setTimeout(() => {
            this.$router.push('/home')
          }, 2000)
        } else {
          this.errorMessage = response.data.msg || '卡密验证失败，请检查后重试'
        }
      } catch (error) {
        this.isLoading = false
        
        if (error.response) {
          // 服务器返回错误状态码
          this.errorMessage = error.response.data.msg || '服务器错误，请稍后重试'
        } else if (error.request) {
          // 请求已发出但没有收到响应
          this.errorMessage = '网络连接失败，请检查网络设置'
        } else {
          // 其他错误
          this.errorMessage = '验证过程中发生错误，请重试'
        }
        
        console.error('卡密验证错误:', error)
      }
    },
    async handleLoginClick() {
      if (this.showRegisterForm) {
        this.showRegisterForm = false
        this.errorMessage = ''
        this.successMessage = ''
        return
      }
      await this.validateLicense()
    },
    async handleRegisterClick() {
      if (!this.showRegisterForm) {
        this.showRegisterForm = true
        this.errorMessage = ''
        this.successMessage = ''
        return
      }
      await this.registerLicense()
    },
    async registerLicense() {
      const cardNumberValue = this.registerCardNumber.trim()
      const mailValue = this.registerMail.trim()
      if (!cardNumberValue || !mailValue) {
        this.errorMessage = '请输入注册卡密和邮箱'
        return
      }

      const mailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!mailPattern.test(mailValue)) {
        this.errorMessage = '邮箱格式不正确，请重新输入'
        return
      }

      this.isLoading = true
      this.errorMessage = ''
      this.successMessage = ''

      try {
        const response = await axios.post(API_CONFIG.getFullUrl('/card/card/api/register'), {
          cardNumber: cardNumberValue,
          mail: mailValue
        })

        this.isLoading = false
        if (response.data && response.data.code === 200) {
          this.accountInput = cardNumberValue
          this.successMessage = '注册成功，请点击验证卡密登录'
        } else {
          this.errorMessage = response.data.msg || '注册失败，请检查后重试'
        }
      } catch (error) {
        this.isLoading = false
        if (error.response) {
          this.errorMessage = error.response.data.msg || '服务器错误，请稍后重试'
        } else if (error.request) {
          this.errorMessage = '网络连接失败，请检查网络设置'
        } else {
          this.errorMessage = '注册过程中发生错误，请重试'
        }
        console.error('卡密注册错误:', error)
      }
    }
  }
}
</script>

<style scoped>
.license-check-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  overflow: auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.mall-link {
  position: absolute;
  top: 18px;
  right: 22px;
  z-index: 3;
  font-size: 12px;
  color: rgba(31, 42, 68, 0.72);
  text-decoration: none;
  border: 1px solid rgba(31, 42, 68, 0.18);
  background: rgba(255, 255, 255, 0.3);
  padding: 5px 10px;
  border-radius: 999px;
  transition: all 0.2s ease;
}

.mall-link:hover {
  color: rgba(31, 42, 68, 0.9);
  border-color: rgba(31, 42, 68, 0.28);
  background: rgba(255, 255, 255, 0.45);
}

.background-mask {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.1);
  z-index: 1;
}

.page-shell {
  width: 100%;
  max-width: 1200px;
  min-height: 560px;
  padding: 28px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  z-index: 2;
}

.brand-panel {
  color: #174e9f;
  max-width: 520px;
  padding: 20px 8px;
}

.brand-logo-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 22px;
}

.brand-logo {
  width: 42px;
  height: 42px;
}

.brand-logo-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 1px;
}

.brand-title {
  margin: 0 0 10px;
  font-size: 46px;
  font-weight: 700;
  color: #1551a2;
}

.brand-subtitle {
  margin: 0;
  font-size: 28px;
  color: #2c73c7;
  letter-spacing: 6px;
}

.license-check-card {
  width: 100%;
  max-width: 390px;
  background: rgba(255, 255, 255, 0.97);
  border-radius: 10px;
  border: 1px solid rgba(23, 78, 159, 0.12);
  box-shadow: 0 10px 24px rgba(19, 64, 130, 0.18);
  padding: 24px 22px 20px;
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 18px;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: #1f2a44;
  margin: 0;
}

.tab-line {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.tab-item {
  font-size: 14px;
  color: #6e7687;
  padding-bottom: 6px;
}

.tab-item.active {
  color: #215ed8;
  border-bottom: 2px solid #215ed8;
}

.card-body {
  margin-bottom: 6px;
}

.input-group {
  position: relative;
  margin-bottom: 14px;
}

.license-input {
  width: 100%;
  padding: 11px 12px;
  border: 1px solid #d9deea;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
  background: #fff;
  box-sizing: border-box;
}

.license-input:focus {
  outline: none;
  border-color: #5084eb;
  box-shadow: 0 0 0 3px rgba(80, 132, 235, 0.12);
}

.remember-group {
  margin-bottom: 14px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  color: #637086;
  transition: color 0.3s ease;
}

.checkbox-label:hover {
  color: #333;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox-custom {
  width: 14px;
  height: 14px;
  border: 1px solid #c8cedc;
  border-radius: 2px;
  margin-right: 8px;
  position: relative;
  transition: all 0.3s ease;
  background: white;
}

.checkbox-input:checked + .checkbox-custom {
  background: #4f7ce8;
  border-color: #4f7ce8;
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 10px;
  font-weight: bold;
}

.checkbox-input:focus + .checkbox-custom {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.checkbox-text {
  user-select: none;
}

.validate-btn {
  width: 100%;
  padding: 10px;
  background: #6d95ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.button-group {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.register-form {
  margin-bottom: 2px;
}

.register-input-group {
  margin-bottom: 10px;
}

.register-input-group:last-child {
  margin-bottom: 0;
}

.validate-btn:hover:not(:disabled) {
  background: #5a86f3;
}

.validate-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.register-btn {
  width: 100%;
  padding: 10px;
  background: white;
  color: #4f7ce8;
  border: 1px solid #4f7ce8;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.register-btn:hover:not(:disabled) {
  background: rgba(102, 126, 234, 0.08);
}

.register-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.loading-text {
  display: inline-block;
  animation: pulse 1.2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.error-message {
  background: rgba(255, 71, 87, 0.1);
  border: 1px solid rgba(255, 71, 87, 0.3);
  border-radius: 8px;
  padding: 12px;
  color: #ff4757;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.error-icon {
  margin-right: 8px;
}

.success-message {
  background: rgba(46, 213, 115, 0.1);
  border: 1px solid rgba(46, 213, 115, 0.3);
  border-radius: 8px;
  padding: 12px;
  color: #2ed573;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.success-icon {
  margin-right: 8px;
}

@media (max-width: 1100px) {
  .page-shell {
    max-width: 980px;
  }

  .brand-title {
    font-size: 38px;
  }

  .brand-subtitle {
    font-size: 22px;
  }
}

@media (max-width: 900px) {
  .page-shell {
    min-height: auto;
    justify-content: center;
    padding: 22px 14px;
  }

  .brand-panel {
    display: none;
  }

  .license-check-card {
    max-width: 420px;
  }

  .button-group {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .license-check-card {
    padding: 18px 14px;
  }

  .card-title {
    font-size: 18px;
  }

  .license-input {
    font-size: 13px;
  }
}
</style>
